import React from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import { useTranslation, Trans } from "react-i18next";

const pages = ["book-skp-1.jpg", "book-skp-2.jpg", "book-skp-3.jpg", "book-skp-4.jpg", "book-skp-5.jpg"];

const SiKembarBook = () => {
  const { t } = useTranslation();
  const timeInterval = 3000;

  return (
    <section className="section-sikembar-book bg-blue">
      <Container style={{ position: "relative" }}>
        <Row className="align-items-center jua" style={{ fontWeight: 400 }}>
          <Col md={5} lg={6} className="text-center">
            <Carousel fade interval={timeInterval} className="banner-area-desktop">
              {pages.map((item, index) => (
                <Carousel.Item key={index}>
                  <img className="w-100 img-fluid banner-image" src={"../assets/images/" + item} alt="why-sikembar" style={{ borderRadius: "16px" }} />
                </Carousel.Item>
              ))}
            </Carousel>
          </Col>
          <Col md={7} lg={6} className="subsection-title">
            <Trans
              i18nKey="intro-skbb-desc"
              components={{
                ul: <ul />,
                li: <li />,
              }}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SiKembarBook;
